import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-1 mx-2 mt-2" }
const _hoisted_2 = { class: "order-2 mt-2 leading-6 font-medium text-gray-400 whitespace-nowrap" }
const _hoisted_3 = { class: "order-1 text-xl sm:text-4xl leading-none font-extrabold text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dt", _hoisted_2, [
      _renderSlot(_ctx.$slots, "name")
    ]),
    _createElementVNode("dd", _hoisted_3, [
      _renderSlot(_ctx.$slots, "value")
    ])
  ]))
}